import ContactMe from "../ContactMe";
import Footer from "../Footer";
import HeroSection from "../HeroSection";
import Experience from "../Experience";
import MySkills from "../MySkills";
import GoToTop from "../GoToTop";
import { useEffect, useRef, useState } from "react"
import Navbar from "../Navbar";


export default function Home(){

    const [showOrHide, setShowOrHide] = useState('s-back-to-top')

    const handleScrollUp = () =>{
        refScrollUp.current.scrollIntoView({behavior:'smooth'});
    }
    const handleWindowScrolled = () =>{
        const position = window.scrollY;
        if(position > 50){
            return setShowOrHide('s-back-to-top -is-visible')
        }
        else{
            return setShowOrHide('s-back-to-top')
        }
    }
    const refScrollUp = useRef();
    useEffect(() =>{
        window.addEventListener('scroll', handleWindowScrolled);
    },[])

    return (
        
        <>
            <HeroSection scrollref={refScrollUp} />
            <Navbar />
            <MySkills />
            <Experience />
            <ContactMe />
            <Footer />
            <GoToTop showGoTop={showOrHide} scrollUp={handleScrollUp} />
        </>
    )
}